import { render, staticRenderFns } from "./LicenseUpdate.vue?vue&type=template&id=46ede424&scoped=true"
import script from "./LicenseUpdate.vue?vue&type=script&lang=js"
export * from "./LicenseUpdate.vue?vue&type=script&lang=js"
import style0 from "./LicenseUpdate.vue?vue&type=style&index=0&id=46ede424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ede424",
  null
  
)

export default component.exports